module.exports = __webpack_public_path__ + "static/media/Logo.6ab56d78.png";